const getCurrentDate = function (): string {
  const D = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Rome' }));
  const YYYY = D.getFullYear().toString();
  const MM = (D.getMonth() + 1).toString().padStart(2, '0');
  const DD = D.getDate().toString().padStart(2, '0');
  const hh = D.getHours().toString().padStart(2, '0');
  const mm = D.getMinutes().toString().padStart(2, '0');
  const ss = D.getSeconds().toString().padStart(2, '0');
  return `${YYYY}/${MM}/${DD} ${hh}:${mm}:${ss}`;
};

const fromSecondsToDate = (
  totalSeconds: number
): {time: string} => {
  const totalMinutes = Math.floor(totalSeconds / 60);

  const remainingSeconds = Math.round(totalSeconds % 60);

  const totalHours = Math.floor(totalMinutes / 60);

  const remainingMinutes = totalMinutes % 60;

  const time = `${totalHours.toString().padStart(2, '0')}:${remainingMinutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;

  return { time };
};

// Event Bus for component communication
type EventCallback = (...args: unknown[]) => void;
const eventListeners: { [key: string]: EventCallback[] } = {};

const eventBus = {
  on: (event: string, callback: EventCallback) => {
    if (!eventListeners[event]) {
      eventListeners[event] = [];
    }
    eventListeners[event].push(callback);
  },
  off: (event: string, callback: EventCallback) => {
    if (eventListeners[event]) {
      eventListeners[event] = eventListeners[event].filter(cb => cb !== callback);
    }
  },
  emit: (event: string, ...args: unknown[]) => {
    if (eventListeners[event]) {
      eventListeners[event].forEach(callback => callback(...args));
    }
  }
};

export {
  getCurrentDate,
  fromSecondsToDate,
  eventBus
};